import React from 'react';
import { Star } from 'lucide-react';

const ReviewOverview = ({ averageRating, totalReviews, ratingStats }) => {
  return (
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 bg-white/60 backdrop-blur-xl p-8 rounded-[3rem] border border-white/50 shadow-sm">
      <div className="space-y-2">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-primary">Guest Reviews</h1>
        <p className="text-gray-500 font-medium">Hear what your guests are saying about their dining experience.</p>
      </div>

      <div className="flex items-center gap-6">
        <div className="text-center">
          <div className="text-5xl font-black text-gray-900 leading-none mb-2">{averageRating}</div>
          <div className="flex gap-1 justify-center mb-1">
            {[1, 2, 3, 4, 5].map((star) => (
              <Star
                key={star}
                size={16}
                className={`${star <= Math.round(averageRating) ? 'fill-yellow-400 text-yellow-400' : 'text-gray-200'}`}
              />
            ))}
          </div>
          <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">{totalReviews} TOTAL REVIEWS</p>
        </div>

        <div className="h-16 w-px bg-gray-100 hidden sm:block"></div>

        <div className="hidden sm:flex flex-col gap-1 min-w-[150px]">
          {[5, 4, 3, 2, 1].map((rating) => {
            const percentage = ratingStats[rating] || 0;
            return (
              <div key={rating} className="flex items-center gap-2">
                <span className="text-[10px] font-bold text-gray-500 w-3">{rating}</span>
                <div className="flex-1 h-1.5 bg-gray-100 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-yellow-400 rounded-full transition-all duration-1000"
                    style={{ width: `${percentage}%` }}
                  ></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ReviewOverview;
